// ბუღალტერია — the owner's accounting screens. The accountant's Excel, the
// inventory CSV and the printed invoice stay Georgian (documents).
export const accounting = {
  'history.loading': 'გაყიდვების ისტორია იტვირთება…',
  'history.failed': 'ისტორია ვერ ჩაიტვირთა.',
  'history.retry': 'თავიდან ცდა',
  'acc.chart.revenue': 'შემოსავალი',
  'acc.chart.profit': 'საერთო მოგება',
  'acc.page.1': 'ყველა ფილიალი',
  'acc.page.2': 'ნაჩვენებია ფილიალის „',
  'acc.page.3': '" გაყიდვები, შესყიდვები, ხარჯები და ნისიის დაფარვები · ნისიის ნაშთი ყველა ფილიალისაა, რადგან კლიენტი კომპანიისაა და არა ფილიალის',
  'acc.page.4': 'პერიოდის მაჩვენებლები',
  'acc.page.5': 'ტენდენცია და ყურადღება',
  'acc.page.6': 'ოპერაციები',
  'acc.pulse.1': 'ცვლა {p1} გაიხსნა და ჯერ ღიაა',
  'acc.pulse.2': 'დახურე და დაითვალე სალარო',
  'acc.pulse.3': '{p1} ცვლა დიდი ხანია ღიაა',
  'acc.pulse.4': 'სალაროდან გაიტანეს ₾{total} — დღეს და ღია ცვლაში',
  'acc.pulse.5': 'გადახდის ფანჯრის შემდეგ კალათიდან ამოიღეს — ₾{afterTotal}',
  'acc.pulse.6': ' · შეადარე კამერას',
  'acc.pulse.7': 'დღეს კალათიდან გაუყიდავად ამოიღეს ₾{total} — {p1}-ჯერ',
  'acc.pulse.8': '„{product_name}"-ის ფასი დროებით დაიწია და დაბრუნდა',
  'acc.pulse.9': '{p1} პროდუქტის ფასი დროებით დაიწია და დაბრუნდა',
  'acc.pulse.10': '{p1} ელოდება თანხას',
  'acc.pulse.11': '{p1} ყოველთვიური ხარჯი ელოდება თანხას',
  'acc.pulse.12': 'ჩაწერე, რამდენი გადაიხადე',
  'acc.pulse.13': '60 დღეა ხარჯი არ ჩაწერილა — მოგება ნამდვილზე მეტს აჩვენებს',
  'acc.pulse.14': 'ქირა, ხელფასი, კომუნალური — დაამატე ერთხელ „ყოველთვიურ ხარჯებში"',
  'acc.pulse.15': '{p1} პროდუქტი ამოწურულია',
  'acc.pulse.16': '„{name}" სწრაფად იყიდება',
  'acc.pulse.17': '{VELOCITY_DAYS} დღეში გაიყიდა {sold}, დარჩა {stock} — შეუკვეთე {suggest}',
  'acc.pulse.18': '{p1} პროდუქტს მარაგი ეწურება (≤{LOW_STOCK})',
  'acc.pulse.19': '{p1} პროდუქტი თვითღირებულებაზე იაფად იყიდება',
  'acc.pulse.20': 'გაიმეორე ისტორიიდან',
  'acc.pulse.21': '{p1} პროდუქტი {DEAD_DAYS}+ დღეა არ იყიდება',
  'acc.pulse.22': 'ჩაკეტილი თანხა: ₾{deadValue}',
  'acc.pulse.23': 'ნისიის ვალები: ₾{debtTotal}',
  'acc.pulse.24': 'გააგზავნე შეხსენება',
  'acc.pulse.25': 'მომწოდებლების ვალი: ₾{supplierDebt}',
  'acc.pulse.26': ' საჭიროებს ყურადღებას',
  'acc.pulse.27': 'მარაგის შეტყობინებები ფილიალისთვის: ',
  'acc.pulse.28': 'ყველაფერი წესრიგშია',
  'acc.pulse.29': ' დატვირთული საათები',
  'acc.pulse.30': 'გაყიდვების სიხშირე · ბოლო 30 დღე',
  'acc.pulse.31': 'პიკი',
  'acc.pulse.32': 'ჯერ საკმარისი მონაცემი არ არის',
  'acc.pulse.33': '{p1} {p2}:00 — {v} გაყიდვა',
  'acc.pulse.34': 'დაბრუნება — ₾{total}',
  'acc.pulse.35': 'გაყიდვა ₾{total}{p1}',
  'acc.pulse.36': 'ნისიის დაფარვა — ₾{amount}',
  'acc.pulse.37': 'მომწოდებელზე გადახდა — ₾{amount}',
  'acc.pulse.38': 'ხარჯი: {p1} — ₾{amount}',
  'acc.pulse.39': 'სალაროდან −₾{amount} · {p1}{p2}',
  'acc.pulse.40': 'სალაროში +₾{amount} · {p1}{p2}',
  'acc.pulse.41': 'ცვლა გაიხსნა{p1}',
  'acc.pulse.42': 'ცვლა დაიხურა{p1}',
  'acc.pulse.43': ' ბოლო აქტივობა',
  'acc.pulse.44': 'აქტივობა ჯერ არ არის',
  'acc.pulse.45': 'სრული ჟურნალი ',
  'acc.drawer.1': 'სულ {p1}',
  'acc.drawer.2': 'კასიდან გატანილი',
  'acc.drawer.total': 'სულ გატანილი',
  'acc.drawer.3': 'ნაღდი, რომელიც სალაროდან გავიდა — ცვლის დახურვისას და ცვლის შუაში. ეს ნავაჭრი არ არის: ბარათით გაყიდულის ბანკები ზემოთ, „ბარათის" სვეტშია.',
  'acc.drawer.4': 'ამ პერიოდში სალაროდან არაფერი გასულა.',
  'acc.pocket.title': 'მფლობელის ჯიბე',
  'acc.pocket.sub': 'რამდენი წაიღე სალაროდან და რამდენი ჩადე საქონელში პირადი თანხით. ეს არც შემოსავალია და არც მოგება.',
  'acc.pocket.took': 'სალაროდან წაიღე',
  'acc.pocket.goods': 'საქონელში ჩადე პირადი თანხით',
  'acc.pocket.kept': 'შენთან დარჩა',
  'acc.pocket.added': 'ჯიბიდან დაამატე',
  'acc.pocket.unnamed': '{n} შესყიდვას (₾{sum}) წყარო არ აქვს მითითებული — ეს ციფრი მათ არ ითვალისწინებს.',
  // 1.53 (168) — the change rounding, the owner's card
  'acc.tetri.title': 'ხურდის თეთრები',
  'acc.tetri.sub': 'რამდენი თეთრი დარჩა ან დავამატეთ ხურდის დამრგვალებისას. გაყიდვებში, მოგებაში, ჩეკსა და RS.GE-ში არ შედის — მხოლოდ სალაროს ნაღდია, რომ ცვლა ზუსტად დაჯდეს.',
  'acc.tetri.kept': 'მაღაზიას დარჩა',
  'acc.tetri.given': 'დავამატეთ / ვაპატიეთ',
  'acc.tetri.count': '{n} გაყიდვა',
  'acc.ev.1': 'კამერის დრო',
  'acc.ev.2': 'დრო დაკოპირდა — მოძებნე CCTV აპში',
  'acc.ev.3': 'კოპირება ვერ მოხერხდა',
  'acc.ev.4': 'დროის კოპირება',
  'acc.ev.5': 'გახსენი კამერის ჩანაწერში',
  'acc.ev.6': 'ბარათი{p1}',
  'acc.ev.7': 'ნაღდი',
  'acc.ev.8': 'შერეული',
  'acc.ev.9': 'გადარიცხვა{p1}',
  'acc.ev.10': 'ნისია',
  'acc.ev.11': 'დაბრუნება — ₾{total}',
  'acc.ev.12': 'გაყიდვა — ₾{total} · {p1}',
  'acc.ev.13': 'შესყიდვა — ₾{total}',
  'acc.ev.14': 'ხარჯი: {p1} — ₾{amount}',
  'acc.ev.15': 'სალაროდან გატანა',
  'acc.ev.16': 'სალაროში შეტანა',
  'acc.ev.17': 'ნისიის დაფარვა — ₾{amount} · {p1}',
  'acc.ev.18': 'მომწოდებელზე გადახდა — ₾{amount} · {p1}',
  'acc.ev.19': 'ცვლა გაიხსნა — საწყისი ₾{opening_cash}{gapTail}',
  'acc.ev.20': ' · გაიტანეს ₾{taken} ({p1}{p2}), დარჩა ₾{p3}',
  'acc.ev.salary': ' · ხელფასი ₾{amount}',
  'acc.ev.21': 'გადახდის ფანჯრის გახსნის შემდეგ',
  'acc.ev.22': 'ნაჩვენებია ამ ცვლის დღეების მოვლენები',
  'acc.ev.23': 'დანაკარგების კონტროლი',
  'acc.ev.24': 'რა გავიდა კალათიდან გაუყიდავად და ვინ შეცვალა ფასი — არჩეულ თარიღებში',
  'acc.ev.25': 'ამ თარიღებში კალათიდან გაუყიდავად არაფერი ამოუღიათ და ფასი არ შეცვლილა.',
  'acc.ev.30': 'ფასის ცვლილება',
  'acc.ev.33': 'ფასი დროებით დაიწია და უკან დაბრუნდა',
  'acc.ev.36': 'შეამოწმე ამ შუალედის გაყიდვები — ხომ არ გაიყიდა დაწეულ ფასად.',
  'acc.ev.37': 'ძებნა — თანხა, მოლარე, კლიენტი...',
  'acc.ev.38': 'ყველა მოლარე',
  'acc.ev.40': 'ამ ფილტრებით მოვლენა ვერ მოიძებნა',
  'acc.ev.41': 'ფასდაკლება',
  'acc.ev.42': 'ბონუსით',
  'acc.ev.43': 'ბონუსი დაერიცხა',
  'acc.ev.44': 'ფისკალური ჩეკი',
  'acc.ev.45': 'კალათის ჯამი იყო',
  'acc.ev.46': 'გადახდის ფანჯარა ამ კალათისთვის უკვე გახსნილი იყო — მყიდველმა ჯამი ნახა. შეადარე კამერას.',
  'acc.ev.47': '🔍 აჩვენე ამ ცვლის მოვლენები',
  'acc.ev.48': 'მეტის ჩვენება (',
  'acc.ev.49': ' დარჩა)',
  'acc.exp.1': 'შეიყვანეთ ვალიდური თანხა',
  'acc.exp.2': 'ნაჩვენებია მხოლოდ ფილიალის „',
  'acc.exp.3': '" ხარჯები · აქ დამატებული ხარჯიც ამ ფილიალს ჩაეწერება',
  'acc.exp.4': ' ფილიალის გარეშე — არ ჩანს ამ სიაში',
  'acc.exp.5': 'ხარჯები ამ პერიოდში',
  'acc.exp.6': 'ხარჯის დაფიქსირება',
  'acc.exp.7': 'თანხა ₾',
  'acc.exp.8': 'შენიშვნა (არასავალდ.)',
  'acc.exp.9': 'კონტრაგენტის ს/კ (არასავალდ.)',
  'acc.exp.10': 'თუ ხარჯი გადახდილია რეგისტრირებულ კომპანიაზე (ქირა, კომუნალური) — ს/კ სჭირდება ბუღალტერს დღგ-ს ჩასათვლელად',
  'acc.exp.11': ' დამატება',
  'acc.exp.12': 'ამ პერიოდში ხარჯები არ არის',
  'acc.exp.13': 'სალაროდან · ',
  'acc.exp.14': 'ყოველთვიური · ',
  'sync.tagOffline': 'ოფლაინ',
  'sync.tagOdd': 'ოფლაინ · განსხვავებით',
  'sync.tagLate': 'დახურვის შემდეგ',
  'sync.offline': 'გაიყიდა ინტერნეტის გარეშე, გაიგზავნა მოგვიანებით',
  'sync.late': 'შემოვიდა მას შემდეგ, რაც მისი ცვლა დაიხურა — ამ ცვლის Z-ში არ არის',
  'sync.price': 'ძველი ფასით: {name} ₾{sent} (ახლა ₾{list})',
  'sync.promo': 'აქცია „{name}" უკვე აღარ მოქმედებდა',
  'sync.stock': 'მარაგი არ ეყო: {name} — გაიყიდა {sold}, იყო {had}',
  'sync.clock': 'მითითებული დრო ვერ მივიღეთ — ჩაიწერა მიღების დროით',
  'acc.exp.closeSalaryShort': 'ცვლის დახურვა · ',
  'acc.exp.15': ' · ს/კ {vendor_tin}',
  'acc.exp.16': 'ხარჯის წაშლა',
  'acc.exp.17': 'კატეგორია',
  'acc.exp.18': 'თანხა',
  'acc.exp.19': 'თარიღი',
  'acc.exp.20': 'სალაროდან',
  'acc.exp.21': 'ყოველთვიური',
  'acc.exp.22': '· ს/კ ',
  'acc.exp.23': 'წავშალოთ ხარჯი?',
  'acc.exp.24': 'ეს ხარჯი ცვლის დროს სალაროდან გაიცა. წაიშლება მხოლოდ ხარჯებიდან (მოგებიდან) — სალაროს ჩანაწერი და ცვლის დათვლა უცვლელი დარჩება.',
  'acc.exp.25': 'ეს ყოველთვიური ხარჯის ერთი თვეა. წაიშლება მხოლოდ ეს თვე — თავიდან აღარ ჩაიწერება, შემდეგი თვეები კი ჩვეულებრივ ჩაიწერება. საერთოდ თუ აღარ გინდა, ზემოთ „ყოველთვიურ ხარჯებში" შეაჩერე ან წაშალე.',
  'acc.exp.26': 'ეს მოქმედება ვერ დაბრუნდება.',
  'acc.exp.closeSalary': 'ცვლის დახურვა',
  'acc.exp.closeSalaryDel': 'ეს ხელფასი ცვლის დახურვისას გაიცა. წაიშლება მხოლოდ ხარჯებიდან (მოგებიდან) — ცვლის Z-რეპორტი უცვლელი დარჩება.',
  'acc.fiscal.1': 'მოთხოვნა ვერ შესრულდა',
  'acc.fiscal.2': 'კავშირი ვერ შედგა',
  'acc.fiscal.3': 'RS.GE ჯერ დაკავშირებული არაა',
  'acc.fiscal.4': 'სალარო აპარატის Z-ანგარიშების სანახავად საჭიროა rs.ge-ის სერვის მომხმარებელი.',
  'acc.fiscal.5': ' პარამეტრებში გადასვლა',
  'acc.fiscal.6': 'ჩვენი ცვლები ↔ RS.GE-ს Z-ანგარიშები',
  'acc.fiscal.7': 'რაც ჩვენ ჩავწერეთ, შედარებული იმასთან, რაც სალარო აპარატმა საგადასახადოს გადასცა',
  'acc.fiscal.8': ' · აპარატი ',
  'acc.fiscal.9': ' დღე',
  'acc.fiscal.10': 'განახლება',
  'acc.fiscal.11': 'თუ წერია „მომხმარებელი ან პაროლი არასწორია" — rs.ge-ზე სერვის მომხმარებელს შეიძლება უფლება აკლდეს: დამატებითი სერვისები → სალ. აპარატების დეტალური Z ინფორმაცია. მონიშვნის შემდეგ ',
  'acc.fiscal.12': ' აუცილებელია.',
  'acc.fiscal.13': ' იტვირთება RS.GE-დან…',
  'acc.fiscal.14': 'ემთხვევა',
  'acc.fiscal.15': 'სხვაობით',
  'acc.fiscal.16': 'მხოლოდ RS.GE-ში',
  'acc.fiscal.17': 'მხოლოდ ჩვენთან',
  'acc.fiscal.18': 'არცერთი დღე არ ემთხვევა — სავარაუდოდ სხვა ბიზნესის აპარატია',
  'acc.fiscal.19': 'Z-ანგარიშები მოდის იმ საიდენტიფიკაციო ნომერზე, რომლითაც rs.ge-ის სერვის მომხმარებელია შექმნილი. თუ ის ამ მაღაზიის ნომერი არაა, შედარებას აზრი არ აქვს — ეს ხარვეზი არაა.',
  'acc.fiscal.20': 'მხოლოდ შესადარებელი დღეები (სადაც ორივე მხარეს არის მონაცემი)',
  'acc.fiscal.21': 'არცერთ დღეს არ აქვს ორივე მხარეს მონაცემი',
  'acc.fiscal.22': 'ამ პერიოდში მონაცემი არ არის',
  'acc.fiscal.23': 'ჩვენ ',
  'acc.fiscal.24': 'ნაღდი ',
  'acc.fiscal.25': ' · ბარათი ',
  'acc.fiscal.26': 'ჩვენთან ცვლა არაა',
  'acc.fiscal.27': 'RS.GE-ში Z არაა',
  'acc.fiscal.28': ' ემთხვევა',
  'acc.fiscal.29': 'თარიღი',
  'acc.fiscal.30': 'RS.GE ნაღდი',
  'acc.fiscal.31': 'RS.GE ბარათი',
  'acc.fiscal.32': 'RS.GE სულ',
  'acc.fiscal.33': 'ჩვენი სულ',
  'acc.fiscal.34': 'სხვაობა',
  'acc.fiscal.35': 'RS.GE მეტია',
  'acc.fiscal.36': ' — გაყიდვა აპარატზე გატარდა, ჩვენს პროგრამაში კი არა (საქონელი უჩუმრად გავიდა).',
  'acc.fiscal.37': 'ჩვენ მეტი გვაქვს',
  'acc.fiscal.38': ' — ჩეკი ფისკალურად ვერ გავიდა. შედარება თარიღით ხდება: დღის ყველა ცვლა ჯამდება, რადგან აპარატი დღეში ერთ Z-ს ხურავს.',
  'acc.hero.1': 'დილა მშვიდობისა',
  'acc.hero.2': 'შუადღე მშვიდობისა',
  'acc.hero.3': 'საღამო მშვიდობისა',
  'acc.hero.4': 'დღევანდელი წმინდა მოგება',
  'acc.hero.5': 'ყველა ფილიალი',
  'acc.hero.9': ' ტოპ კატეგორია ',
  'acc.hero.10': ' დღის მოლარე ',
  'acc.hero.11': ' ყველაფერი წესრიგშია',
  'acc.hero.12': 'ცვლა {p1} გაიხსნა',
  'acc.hero.13': '{p1} ცვლა დიდი ხანია ღიაა',
  'acc.hero.14': 'დახურე და დაითვალე სალარო',
  'acc.hero.15': '{outOfStock} ამოწურულია',
  'acc.hero.16': '{lowStock} იწურება',
  'acc.hero.17': 'შეავსე მარაგი',
  'acc.hero.19': 'ბოლო 90 დღეში · ',
  'acc.hero.20': 'საჭიროებს გამეორებას',
  'acc.hero.21': 'ნისია ₾',
  'acc.hero.23': ' · ყველა ფილიალი',
  'acc.window.1': 'კიდევ {SALES_WINDOW_DAYS} დღე',
  'acc.window.2': 'სრული ისტორია',
  'acc.window.3': 'ჩატვირთე {p1}-დან',
  'acc.inv.1': 'ნაშთი და ღირებულება ფილიალისთვის: ',
  'acc.inv.2': 'პროდუქტის სახეობა',
  'acc.inv.3': 'საწყობის ღირებულება',
  'acc.inv.4': 'პოტენციური შემოსავალი',
  'acc.inv.5': 'მცირე მარაგი · ',
  'acc.inv.6': ' ერთ.',
  'acc.inv.7': 'და კიდევ ',
  'acc.inv.8': 'სრული ასორტიმენტი',
  'acc.inv.9': ' ანგარიში',
  'acc.inv.10': ' · გაყ. ₾',
  'acc.inv.11': 'მარჯვნივ: საწყობის ღირებულება და, მწვანედ, გაყიდვის ფასით.',
  'acc.inv.12': 'მეტის ჩვენება · ',
  'acc.inv.13': 'პროდუქტების სახეობა',
  'acc.inv.14': 'პოტ. შემოსავალი',
  'acc.inv.15': 'მცირე მარაგი',
  'acc.inv.16': ' — სრული სია საწყობში, მარაგით დალაგებით',
  'acc.inv.17': 'კატალოგის შესასწორებლად — საწყობი → ექსპორტი',
  'acc.inv.18': 'ანგარიში (CSV)',
  'acc.inv.19': 'სახელი',
  'acc.inv.20': 'კატეგ.',
  'acc.inv.21': 'მარაგი',
  'acc.inv.22': 'შეს. ფასი',
  'acc.inv.23': 'გაყ. ფასი',
  'acc.inv.24': 'ღირებ.',
  'acc.inv.25': 'პოტ.',
  'acc.invoice.1': 'ჩაწერე კომპანიის დასახელება',
  'acc.invoice.2': 'ინვოისი {p1} გაიცა',
  'acc.invoice.3': 'აირჩიე მყიდველი',
  'acc.invoice.4': ' ინვოისი',
  'acc.invoice.5': 'გაყიდვა ',
  'acc.invoice.6': ' იტვირთება…',
  'acc.invoice.7': 'გაცემულია',
  'acc.invoice.8': 'ს/კ ',
  'acc.invoice.9': ' ბეჭდვა / PDF',
  'acc.invoice.10': 'ამ გაყიდვაზე ინვოისი ჯერ არ გაცემულა.',
  'acc.invoice.11': ' ახალი კომპანია — კლიენტად შეინახება',
  'acc.invoice.12': 'სიიდან არჩევა',
  'acc.invoice.13': 'დასახელება (მაგ. შპს „ალფა“)',
  'acc.invoice.14': 'საიდენტიფიკაციო კოდი (ს/კ)',
  'acc.invoice.15': 'იურიდიული მისამართი',
  'acc.invoice.16': 'მყიდველი',
  'acc.invoice.17': ' ახალი კომპანია',
  'acc.invoice.18': 'აირჩიე კლიენტი…',
  'acc.invoice.19': 'კლიენტი არ არის — დაამატე ნისიაში',
  'acc.invoice.20': ' კომპანიის მონაცემები — ინახება კლიენტის ბარათზე',
  'acc.invoice.21': 'იურიდიული დასახელება (ცარიელი = „{name}")',
  'acc.invoice.22': 'ინვოისი მიიღებს შემდეგ ნომერს (',
  'acc.invoice.23': 'INV-…). გაცემულს ვეღარ შეცვლი — ხელახლა ბეჭდვა ყოველთვის შეიძლება.',
  'acc.invoice.24': ' საბანკო რეკვიზიტები პარამეტრებში არ არის — ინვოისზე არ დაიბეჭდება.',
  'acc.invoice.25': ' ინვოისის გაცემა და ბეჭდვა',
  'acc.invoice.26': 'RS.GE-ის მომხმარებელი პარამეტრებში არ არის',
  'acc.invoice.27': 'RS.GE-სთან კავშირი ვერ შედგა',
  'acc.invoice.28': 'უკვე ატვირთულია',
  'acc.invoice.29': 'პროექტი შეინახა, მაგრამ ხაზები არ ემთხვევა — არ გაგზავნო',
  'acc.invoice.30': 'პროექტი აიტვირთა RS.GE-ზე',
  'acc.invoice.31': 'ანგარიშ-ფაქტურა გაიგზავნა',
  'acc.invoice.32': 'RS.GE-დან განახლდა',
  'acc.invoice.33': 'ინტერნეტი არ არის — სცადე მოგვიანებით',
  'acc.invoice.34': 'RS.GE ანგარიშ-ფაქტურა',
  'acc.invoice.35': 'ინვოისი აიტვირთება ',
  'acc.invoice.36': 'პროექტად',
  'acc.invoice.37': ' — მყიდველი მას ვერ დაინახავს, სანამ არ გაგზავნი.',
  'acc.invoice.38': 'მყიდველის ს/კ არ არის ან არასწორია — ანგარიშ-ფაქტურა ვერ აიტვირთება.',
  'acc.invoice.39': ' RS.GE-ზე ატვირთვა (პროექტი)',
  'acc.invoice.40': 'ნომერი',
  'acc.invoice.41': 'სტატუსი',
  'acc.invoice.42': 'ხაზები',
  'acc.invoice.43': ' ემთხვევა ინვოისს',
  'acc.invoice.44': ' არ ემთხვევა',
  'acc.invoice.45': 'შეუმოწმებელი',
  'acc.invoice.46': 'RS.GE-ზე შენახული ხაზები ამ ინვოისს არ ემთხვევა. ასეთი არ იგზავნება — შეამოწმე RS.GE-ის პორტალში (ანგარიშ-ფაქტურები).',
  'acc.invoice.47': ' გადამოწმება',
  'acc.invoice.48': ' გაგზავნა',
  'acc.invoice.49': 'გაგზავნის შემდეგ RS.GE ანგარიშ-ფაქტურას ',
  'acc.invoice.50': 'ნომერს მიანიჭებს',
  'acc.invoice.51': ', მყიდველი მას დაინახავს და',
  'acc.invoice.52': ' დღგ-ს ჩაითვლის. გაუქმება მხოლოდ RS.GE-ის პორტალიდან შეიძლება, კორექტირებით.',
  'acc.invoice.53': ' დიახ, გაგზავნე',
  'acc.invoice.54': 'არა',
  'acc.kpi.1': 'შემოსავალი',
  'acc.kpi.2': 'მაღაზიაში შემოსული ფული · {count} გაყიდვა',
  'acc.kpi.3': 'საქონლის შესყიდვა',
  'acc.kpi.4': '+ ₾{unattributedPurchases} ფილიალის გარეშე ჩაწერილი — არ ჩანს ამ ხედში',
  'acc.kpi.5': 'საქონელში ჩადებული ფული (ნაწილი ჯერ საწყობშია)',
  'acc.kpi.6': 'საოპერაციო ხარჯები',
  'acc.kpi.7': '+ ₾{unattributedExpenses} ფილიალის გარეშე ჩაწერილი — არ ჩანს ამ ხედში',
  'acc.kpi.8': 'ქირა, ხელფასი, კომუნალური და სხვ.',
  'acc.kpi.9': 'წმინდა მოგება',
  'acc.kpi.10': 'მარჟა {margin}% · შემოსავალი − თვითღირებულება − ხარჯები',
  'acc.kpi.11': 'შემოსავალი − გაყიდულის თვითღირებულება − ხარჯები',
  'acc.kpi.12': 'საშუალო ქვითარი',
  'acc.kpi.13': 'საშუალო თანხა ერთ გაყიდვაზე',
  'acc.metric.1': 'წინა: {p1} · ',
  'acc.money.1': 'ნაღდი',
  'acc.money.2': 'ბარათი',
  'acc.money.3': 'გადარიცხვა',
  'acc.money.4': 'ბანკი უცნობია ₾{p1}',
  'acc.money.5': 'გაყიდვები',
  'acc.money.6': 'ნისიის დაფარვა',
  'acc.money.7': 'ნისიის ავანსი',
  'acc.money.8': 'დაბრუნებები',
  'acc.money.9': 'ნაღდით გაყიდული',
  'acc.money.10': 'ტერმინალი არ იყო მითითებული გაყიდვისას',
  'acc.money.11': 'დაუზუსტებელი ',
  'acc.money.12': 'ბანკის ტერმინალები',
  'acc.money.13': '+ ნისიის დაფარვა ბარათით ₾',
  'acc.money.14': 'ტერმინალში სულ ₾',
  'acc.money.15': 'ნისია',
  'acc.money.16': '{creditCount} გაყიდვა ვალში',
  'acc.money.17': 'ვალში გაყიდვა არ ყოფილა',
  'acc.money.18': 'მყიდველის ვალი მთელი ბიზნესის წინაშეა, არა ფილიალის — ამიტომ ეს ციფრი ყველა ფილიალზე ერთია და არ უნდა შეიკრიბოს',
  'acc.money.19': 'მიმდინარე ვალი დღეს — არ არის პერიოდზე დაყოფილი',
  'acc.money.20': 'ახლა ვალშია',
  'acc.money.21': ' (ყველა ფილიალი)',
  'acc.money.22': 'დაფარულია:',
  'acc.money.23': 'სულ {p1}',
  'acc.money.24': 'ფული',
  'acc.money.25': 'კასაში შემოსული',
  'acc.money.26': 'ნაღდი არ შემოსულა',
  'acc.money.total': 'ნავაჭრი სულ',
  'acc.money.totalHow': 'ნაღდი + ბარათი + ნისია',
  'acc.money.totalHowPrepaid': 'ნაღდი + ბარათი + ნისია + წინასწარი',
  'acc.money.prepaid': 'წინასწარი თანხიდან',
  'acc.money.prepaidSub': 'სასაჩუქრე ბარათით ან წინასწარი გადახდით',
  'acc.money.ppCard': '+ წინასწარი ბარათით ₾',
  'acc.pp.title': 'წინასწარ მიღებული — გვმართებს',
  'acc.pp.now': 'ახლა',
  'acc.pp.sub': 'სასაჩუქრე ბარათების და წინასწარი გადახდების ნაშთი. მყიდველის ფულია, სანამ ნივთს წაიღებს — ბრუნვაში არ შედის.',
  'acc.pp.gift': 'სასაჩუქრე ბარათები',
  'acc.pp.deposit': 'წინასწარი გადახდები',
  'acc.pp.count': '{n} ღია',
  'acc.pp.in': 'პერიოდში მიღებული:',
  'acc.pp.out': 'დაბრუნებული:',
  'acc.rep.prepaid': 'წინასწარი თანხიდან ₾{sum}',
  'acc.money.totalCount': '{n} გაყიდვა',
  'acc.money.totalNone': 'გაყიდვა არ ყოფილა',
  'acc.money.27': ' ფილიალის გარეშე — არ ჩანს ამ ხედში',
  'acc.out.1': 'ზედნადებები, რომლებიც აქედან გაიცა',
  'acc.out.2': 'სტატუსს ვამოწმებ…',
  'acc.out.3': 'განახლება',
  'acc.out.5': '„შენახული" ზედნადები ჯერ არ არის დოკუმენტი — სანამ არ გააქტიურდება, საქონელი ზედნადების გარეშე გადაადგილდება. გააქტიურება rs.ge-ს კაბინეტში ხდება.',
  'acc.out.6': 'rs.ge-ს გახსნა ',
  'acc.out.7': ' იტვირთება…',
  'acc.out.8': 'აქედან ზედნადები ჯერ არ გაგიცია',
  'acc.out.9': 'გამავალი ზედნადები გაყიდვიდან იქმნება — გაყიდვების ისტორია → „ზედნადები". კაბინეტში პირდაპირ შექმნილი ზედნადები აქ არ ჩანს.',
  'acc.out.10': 'მყიდველი —',
  'acc.out.11': ' · ს/კ {buyer_tin}',
  'acc.out.12': ' გააქტიურება',
  'acc.out.14': 'ქვემოთ ნაჩვენებია ჩვენი ბოლო ჩანაწერი — შესაძლოა კაბინეტში უკვე შეცვლილი იყოს.',
  'acc.out.15': 'სტატუსი RS.GE-დან მოწმდება — შენახულებზე ყოველ გახსნაზე, გააქტიურებულებზე აღარ.',
  'acc.out.16': 'ზედნადების გააქტიურება',
  'acc.out.17': 'გააქტიურების შემდეგ ეს ',
  'acc.out.18': 'ნამდვილი საგადასახადო დოკუმენტია',
  'acc.out.19': ': საქონელი გზაში გამოცხადდება და მყიდველი მას დაინახავს. უკან დაბრუნება აღარ შეიძლება — მხოლოდ გაუქმება, რაც ცალკე ჩანაწერია.',
  'acc.out.20': 'დარწმუნდი, რომ საქონელი მართლა გადის.',
  'acc.out.21': 'დიახ, გავააქტიუროთ',
  'acc.out.22': 'RS.GE-ს ნედლი პასუხი ერთ ზედნადებზე (ტექნიკური)',
  'acc.out.23': 'შიდა ID ან № — ორივე მუშაობს. ეს ორი სხვადასხვა ნომერია: № ქაღალდზე წერია, ID კი — ჩვენს სიაში. გამოადეგება, როცა ბეჭდურ ფორმასა და ჩვენს ეკრანს შორის სხვაობას ამოწმებ. მხოლოდ კითხვაა, არაფერს ცვლის.',
  'acc.out.24': 'გამოთხოვა',
  'acc.out.25': 'იპოვა',
  'acc.out.26': 'შიდა ID-ით',
  'acc.out.27': '№-ით',
  'acc.purch.1': 'შესყიდვა',
  'acc.purch.2': 'სულ დაიხარჯა',
  'acc.purch.3': 'მათ შორის ვალი',
  'acc.purch.4': 'პროდუქტი, შტრიხკოდი ან მომწოდებელი…',
  'acc.purch.5': 'ამ ძებნაზე შესყიდვა არ მოიძებნა',
  'acc.purch.6': 'ამ პერიოდში შესყიდვა არ არის',
  'acc.purch.7': ' ც.',
  'acc.purch.8': 'ვალი ₾',
  'acc.rec.1': 'ელოდება თანხას',
  'acc.rec.2': 'ყოველთვიური ხარჯი, რომლის თანხაც იცვლება — ჩაწერე, რამდენი გადაიხადე',
  'acc.rec.3': '{name} ჩაიწერა — ₾{value}',
  'acc.rec.4': '{name} გამოტოვებულია — შემდეგ თვეს ისევ გკითხავს',
  'acc.rec.5': '{name} — თანხა',
  'acc.rec.6': 'ჩაწერა',
  'acc.rec.7': 'ამ თვეში ეს ხარჯი არ ყოფილა — ჩაწერის გარეშე გადავა შემდეგ თვეზე',
  'acc.rec.8': 'ამ თვეში არა',
  'acc.rec.9': 'ყოველთვიური ხარჯები',
  'acc.rec.10': 'თვეში {p1}₾{total} · ერთხელ დამატებული, ყოველ თვე თავად იწერება',
  'acc.rec.11': 'ერთხელ დაამატე — ყოველ თვე თავად ჩაიწერება',
  'acc.rec.12': 'ქირა, ხელფასი, კომუნალური — დაამატე ერთხელ და ყოველ თვე თავად ჩაიწერება ხარჯებში. ასე მოგება ნამდვილს აჩვენებს, არა მხოლოდ გაყიდვიდან დარჩენილს.',
  'acc.rec.13': 'სხვა…',
  'acc.rec.14': 'თვის ბოლო დღეს',
  'acc.rec.15': 'თვის {day_of_month} რიცხვში',
  'acc.rec.16': 'შეჩერებულია',
  'acc.rec.17': 'შემდეგი: {p1}',
  'acc.rec.18': 'თავად იწერება',
  'acc.rec.19': 'თანხას გკითხავს',
  'acc.rec.20': 'შენახულია — {p1} თანხა ზემოთ გელოდება',
  'acc.rec.21': 'შენახულია — შემდეგი: {p1}',
  'acc.rec.22': 'განახლდა — შემდეგი: {p1}',
  'acc.rec.23': 'შეჩერებულია — ახალი თვეები აღარ ჩაიწერება',
  'acc.rec.24': 'წაიშალა — უკვე ჩაწერილი თვეები ხარჯებში დარჩა',
  'acc.rec.25': 'ყოველთვიური ხარჯი',
  'acc.rec.26': 'ერთხელ დაამატე — ყოველ თვე თავად ჩაიწერება ხარჯებში',
  'acc.rec.27': '{p1} · შემდეგი: {p2}',
  'acc.rec.28': 'შეჩერებულია — ახალი თვეები არ იწერება',
  'acc.rec.29': 'რა ხარჯია',
  'acc.rec.30': 'თანხა ყოველ თვე',
  'acc.rec.31': 'დაახლოებით, თვეში',
  'acc.rec.32': 'თანხა თვეში',
  'acc.rec.33': 'ყოველი თვის',
  'acc.rec.34': 'აირჩიე რიცხვი',
  'acc.rec.35': 'ბოლო დღე',
  'acc.rec.36': '{day} რიცხვი',
  'acc.rec.37': 'თანხა 0-ზე მეტი, თეთრი — ორი ციფრით',
  'acc.rec.38': 'თვის ბოლო დღე',
  'acc.rec.39': '{d} რიცხვი',
  'acc.rec.40': 'შემოხაზული — დღევანდელი რიცხვი · 29–31 მოკლე თვეში თვის ბოლო დღეს ჩაიწერება',
  'acc.rec.41': '{p1} {p2}ც ახლავე ჩაიწეროს',
  'acc.rec.42': '{p1} თანხაც ახლავე მკითხე',
  'acc.rec.43': ' უკვე გავიდა',
  'acc.rec.44': 'ამ თვეში „',
  'acc.rec.45': '" უკვე ჩაწერილია (₾',
  'acc.rec.46': ') — ჩართე მხოლოდ თუ ეს სხვაა',
  'acc.rec.47': 'შენიშვნა ',
  'acc.rec.48': '(არასავალდებულო)',
  'acc.rec.49': 'მაგ. მაღაზიის ქირა, ნინოს ხელფასი',
  'acc.rec.50': 'ფილიალი',
  'acc.rec.51': 'კონტრაგენტის ს/კ',
  'acc.rec.52': 'თუ ხარჯი გადახდილია რეგისტრირებულ კომპანიაზე — ს/კ სჭირდება ბუღალტერს დღგ-ს ჩასათვლელად',
  'acc.rec.53': '+ კონტრაგენტის ს/კ (დღგ-სთვის)',
  'acc.rec.63': 'აირჩიე თვის რიცხვი',
  'acc.rec.64': 'ჩაწერე თანხა',
  'acc.rec.65': 'ცვლილების შენახვა',
  'acc.rec.66': 'წაიშალოს? უკვე ჩაწერილი თვეები ხარჯებში დარჩება.',
  'acc.rec.67': 'არ წაიშალოს',
  'acc.rec.68': ' შეჩერება',
  'acc.rec.69': ' განახლება',
  'acc.rec.70': ' წაშლა',
  'acc.rep.1': 'არასწორი პერიოდი',
  'acc.rep.2': 'ისტორია ჯერ იტვირთება',
  'acc.rep.3': 'ანგარიში ჩამოიტვირთა',
  'acc.rep.4': 'შემოსავალი',
  'acc.rep.5': 'ნაღდი ₾{cash} · ბარათი ₾{card} · ნისია ₾{credit}',
  'acc.rep.6': 'თვითღირებულება (COGS)',
  'acc.rep.7': 'საერთო მოგება',
  'acc.rep.8': 'ოპერაციული ხარჯები',
  'acc.rep.9': 'წმინდა მოგება',
  'acc.rep.10': 'საანგარიშო პერიოდი',
  'acc.rep.11': 'აირჩიე დიაპაზონი და ჩამოტვირთე Excel ბუღალტრისთვის',
  'acc.rep.12': 'ფილიალის ფილტრი',
  'acc.rep.13': 'ყველა ფილიალი',
  'acc.rep.14': 'ეს თვე',
  'acc.rep.15': ' წინა თვე',
  'acc.rep.16': 'ისტორია იტვირთება…',
  'acc.rep.17': 'Excel-ად ჩამოტვირთვა',
  'acc.rep.18': ' მოგება-ზარალი (P&L)',
  'acc.rep.19': 'მცირე ბიზნესი — 1%',
  'acc.rep.20': 'დღგ — 18%',
  'acc.rep.21': 'საორიენტაციო · გადაამოწმეთ ბუღალტერთან',
  'acc.rep.22': 'ბრუნვა (დეკლარაციისთვის)',
  'acc.rep.23': 'გადასახადი ~1%',
  'acc.rep.24': 'შემოსავალი დღგ-ს გარეშე',
  'acc.rep.25': 'დღგ 18%',
  'acc.rep.26': 'გაყიდვები',
  'acc.rep.27': 'დაბრუნებები',
  'acc.rep.28': 'ფასდაკლებები',
  'acc.rep.29': 'აქციებით (ხაზებზე)',
  'acc.rep.30': 'ბონუსით დაფარული · დაერიცხა',
  'acc.rep.31': 'შესყიდვები',
  'acc.rep.32': 'ნისიის დაფარვები (მიღებული)',
  'acc.rep.33': 'მომწოდებლებზე გადახდილი',
  'acc.rep.34': 'ტოპ პროდუქტები ამ პერიოდში',
  'acc.rep.35': 'მოდელი ერთ სტრიქონად — ყველა ზომით ერთად, ქვემოთ ზომებით',
  'acc.rep.36': 'გაყიდვები არ არის',
  'acc.rep.37': ' ც · ',
  'acc.rep.38': 'მხოლოდ ტოპ 5',
  'acc.rep.39': 'ყველას ნახვა ({p1})',
  'acc.ret.1': 'აირჩიეთ დასაბრუნებელი რაოდენობა',
  'acc.ret.2': 'დაბრუნება დაფიქსირდა, მარაგი დაბრუნდა',
  'acc.ret.3': 'ფისკალური დაბრუნების ჩეკი იბეჭდება...',
  'acc.ret.4': 'დაბრუნების ჩეკი გაიცა #{fiscalId}',
  'acc.ret.5': 'დაბრუნების ჩეკი ვერ გაიცა',
  'acc.ret.6': ' საქონლის დაბრუნება',
  'acc.ret.7': 'ნაყიდი: ',
  'acc.ret.8': ' (აქციით)',
  'acc.ret.9': 'დასაბრუნებელი (',
  'acc.ret.10': ' ც.):',
  'acc.ret.11': 'გაყიდვა ნაწილობრივ ბონუსით იყო დაფარული — ნაღდად ბრუნდება ის, რაც რეალურად გადაიხადა, ბონუსი კი კლიენტის ბალანსზე უბრუნდება',
  'acc.ret.12': 'გაყიდვაზე იყო ფასდაკლება — ბრუნდება ის, რაც რეალურად გადაიხადა',
  'acc.ret.14': ' დაბრუნების დადასტურება',
  'acc.chart.1': 'საერთო მარჟა',
  'acc.chart.2': 'ჩეკები ',
  'acc.chart.3': 'საშ. ',
  'acc.chart.4': 'გაყიდვების დინამიკა',
  'acc.chart.5': 'მონაცემი არ არის',
  'acc.hist.1': 'ფისკალური ჩეკი იბეჭდება...',
  'acc.hist.2': 'ჩეკი გაიცა #{fiscalId} — ⚠️ ტესტ-რეჟიმი',
  'acc.hist.3': 'ფისკალური ჩეკი გაიცა #{fiscalId}',
  'acc.hist.4': 'ფისკალური ჩეკი ვერ გაიცა',
  'acc.hist.5': 'ნაღდი',
  'acc.hist.6': 'ბარათი{p1}',
  'acc.hist.7': 'ნისია',
  'acc.hist.8': 'ბარათი',
  'acc.hist.9': 'გაყიდვები ვერ მოიძებნა',
  'acc.hist.10': '{items_count} პოზიცია',
  'acc.hist.11': 'ბონუსით',
  'acc.hist.12': 'ჩეკი ვერ გაიცა',
  'acc.hist.13': 'ჩეკი მუშავდება',
  'acc.hist.14': 'მეტის ჩვენება · ',
  'acc.hist.15': 'გაყიდვა',
  'acc.hist.16': 'აქცია −₾',
  'acc.hist.17': 'ფასების ჯამი',
  'acc.hist.18': 'აქციის დანაზოგი',
  'acc.hist.19': 'ფასდაკლება ',
  'acc.hist.20': 'გადახდილი',
  'acc.hist.21': 'ბონუსი დაერიცხა',
  'acc.hist.22': 'მიღებული ',
  'acc.hist.23': 'ხურდა ',
  'acc.hist.tetri.kept': '{n} თეთრი დარჩა',
  'acc.hist.tetri.added': '{n} თეთრი დავამატეთ',
  'acc.hist.tetri.forgiven': '{n} თეთრი ვაპატიეთ',
  'acc.hist.24': 'ფისკალური ჩეკი #',
  'acc.hist.25': 'ჩეკი მუშავდება…',
  'acc.hist.26': 'ხელახლა',
  'acc.hist.27': ' ჩეკის ბეჭდვა',
  'acc.hist.28': ' ინვოისი',
  'acc.hist.29': ' ზედნადები',
  'acc.hist.30': ' დაბრუნება',
  'acc.hist.31': 'თარიღი',
  'acc.hist.32': 'დრო',
  'acc.hist.33': 'პოზ.',
  'acc.hist.34': 'გადახდა',
  'acc.hist.35': 'სულ',
  'acc.hist.36': 'ბონუსით −₾',
  'acc.hist.37': 'ფასების ჯამი ₾',
  'acc.hist.38': 'აქციის დანაზოგი −₾',
  'acc.hist.39': 'გადახდილი ₾',
  'acc.hist.40': 'ბონუსი დაერიცხა +₾',
  'acc.hist.41': 'ჩეკის ხელახლა ცდა',
  'acc.hist.42': ' ჩეკი',
  'acc.hist.43': 'გვ. ',
  'acc.hist.44': 'წინ',
  'acc.doctor.1': 'შესაძენი',
  'acc.doctor.2': 'გაყინული ფული',
  'acc.doctor.3': 'მარჟის რისკი',
  'acc.doctor.4': 'ვადა',
  'acc.doctor.5': 'მალე ამოიწურება',
  'acc.doctor.6': '{outNow} უკვე ამოიწურა',
  'acc.doctor.7': 'გაყიდვადი პროდუქტი',
  'acc.doctor.8': '{p1} პროდუქტი · საწყობის {deadPct}%',
  'acc.doctor.9': '10%-ზე დაბალი ან ზარალი',
  'acc.doctor.10': 'საწყობის მენეჯერი',
  'acc.doctor.11': 'რა უნდა შევიძინო, რაში მიყრია ფული, სად ვკარგავ მარჟას — შენივე გაყიდვების მიხედვით',
  'acc.doctor.12': 'არცერთი გაყიდვადი პროდუქტი არ არის ამოწურვის ზღვარზე',
  'acc.doctor.13': '{VELOCITY_DAYS} დღეში',
  'acc.doctor.14': 'მარაგი',
  'acc.doctor.15': 'რჩება',
  'acc.doctor.16': ' დღე',
  'acc.doctor.17': 'უძრავი მარაგი არ არის — ყველაფერი მოძრაობს',
  'acc.doctor.20': 'ეს შენი ფულია, რომელიც არ მუშაობს. ფასდაკლება, მომწოდებელთან დაბრუნება, ან უბრალოდ აღარ შეიძინო — გადაწყვეტილება შენია.',
  'acc.doctor.21': 'ბოლო გაყიდვა',
  'acc.doctor.22': 'გაყინული თანხა',
  'acc.doctor.23': 'ამ {SALES_WINDOW_DAYS} დღეში არა',
  'acc.doctor.24': 'ნაჩვენებია ყველაზე ძვირი 60 · სულ ',
  'acc.doctor.25': 'უახლოეს {EXPIRY_SOON} დღეში ვადა არცერთს გასდის',
  'acc.doctor.27': 'ფასდაკლება ახლა — ვადაგასულში მთლიანი თანხა იკარგება.',
  'acc.doctor.28': 'თანხა',
  'acc.doctor.29': 'გავიდა ',
  'acc.doctor.30': 'ყველა პროდუქტს ჯანსაღი მარჟა აქვს',
  'acc.doctor.31': 'თვითღირებულება',
  'acc.doctor.32': 'გასაყიდი',
  'acc.doctor.33': 'მარჟა',
  'acc.totals.1': 'ფილიალი „{scopeName}" · ყველა დროის',
  'acc.totals.2': 'ყველა ფილიალი · ყველა დროის',
  'acc.totals.3': 'საწყობის ღირებულება',
  'acc.totals.4': 'ფილიალის მარაგი იტვირთება…',
  'acc.totals.5': '„{scopeName}"-ში ახლა არსებული საქონელი (თვითღირებულებით)',
  'acc.totals.6': 'ახლა საწყობში არსებული საქონლის ღირებულება (თვითღირებულებით)',
  'acc.totals.7': 'სულ დახარჯული',
  'acc.totals.8': 'ვერ ჩაიტვირთა',
  'acc.totals.9': 'ითვლება…',
  'acc.totals.10': 'შესყიდვა ₾{p1} + საოპერაციო ხარჯები ₾{p2}',
  'acc.totals.10w': 'შესყიდვა ₾{p1} + ხარჯები ₾{p2} · ჩამოწერა ₾{p3} არ ემატება (შესყიდვაშია)',
  'acc.totals.11': 'სულ წმინდა მოგება',
  'acc.totals.12': 'შემოსავალი − გაყიდულის თვითღირებულება − ხარჯები · {scopeNote}',
  'acc.totals.13': 'ფილტრების გარეშე · ყველა ფილიალი',
  'acc.totals.14': 'ბიზნესის სრული სურათი',
  'acc.totals.15': 'ფილიალი „{scopeName}"',
  'acc.totals.16': 'ეს ფილიალი',
  'acc.totals.17': 'მთელი ბიზნესი',
  'acc.totals.18': 'ყველა დროის',
  'acc.totals.19': '· ფილიალის გარეშე: შესყიდვა+ხარჯი ₾',
  'acc.totals.20': ' · შემოსავალი ₾',
  'acc.totals.21': '— ჩაწერილია ფილიალის მითითების გარეშე',
  'acc.totals.22': 'ყველა დროის ციფრები ვერ ჩაიტვირთა — სცადე თავიდან',
  'acc.wb.1': 'RS.GE-ს მიხედვით: ',
  'acc.wb.2': 'ამ კოდზე დასახელება ვერ მოიძებნა',
  'acc.wb.3': 'ზედნადების ტიპი აირჩიე',
  'acc.wb.4': 'ტრანსპორტირების სახე აირჩიე',
  'acc.wb.5': ' გამავალი ზედნადები',
  'acc.wb.6': 'ზედნადები RS.GE-ზე „შენახული" სტატუსით ჩაიწერება. გააქტიურებას შენ აკეთებ rs.ge-ზე — მაშინ ჩაითვლება, რომ საქონელი გზაშია.',
  'acc.wb.7': ' იტვირთება…',
  'acc.wb.8': ' ამ გაყიდვას ზედნადები უკვე აქვს',
  'acc.wb.9': 'RS.GE-ს შიდა ნომერი — ზედნადების № გააქტიურებისას მიენიჭება',
  'acc.wb.10': ' · ს/კ ',
  'acc.wb.11': 'შენახული (გასააქტიურებელია)',
  'acc.wb.12': ' rs.ge — ზედნადებები → შენახული',
  'acc.wb.13': 'კიდევ ერთი ზედნადების შექმნა ამ გაყიდვაზე',
  'acc.wb.14': 'ზედნადებს მხოლოდ მაღაზიის მფლობელი ქმნის.',
  'acc.wb.15': ' RS.GE-ს სიები იტვირთება…',
  'acc.wb.16': 'RS.GE-ს სიები ვერ წამოვიდა.',
  'acc.wb.17': 'შეამოწმე ორი რამ: სერვის მომხმარებელს ზედნადების ',
  'acc.wb.18': '„შექმნა/რედაქტირების"',
  'acc.wb.19': ' უფლება ხომ აქვს (rs.ge → ქვე-მომხმარებლების უფლებების მართვა → ძირითადი მოდულები → ზედნადები), და რომ პარამეტრებში → RS.GE ახალი პაროლია ჩაწერილი. თუ ორივე წესრიგია, გამომიგზავნე ქვემოთ „დეტალების" ტექსტი.',
  'acc.wb.20': 'დეტალები (RS.GE-ს პასუხი)',
  'acc.wb.21': 'თავიდან ცდა',
  'acc.wb.22': 'მყიდველის ს/კ',
  'acc.wb.23': '9 ან 11 ციფრი',
  'acc.wb.24': ' შემოწმება',
  'acc.wb.25': 'მყიდველის დასახელება',
  'acc.wb.26': 'შპს …',
  'acc.wb.27': 'გასვლის მისამართი',
  'acc.wb.28': 'საიდან გადის საქონელი',
  'acc.wb.29': 'ჩაბარების მისამართი',
  'acc.wb.30': 'ტრანსპორტირების გარეშე — საქონელი ადგილზე რჩება',
  'acc.wb.31': 'სად ბარდება',
  'acc.wb.32': 'ზედნადების ტიპი',
  'acc.wb.33': 'ტრანსპორტირების სახე',
  'acc.wb.34': 'რით გადადის საქონელი',
  'acc.wb.35': 'ტრანსპორტირების დაწყება',
  'acc.wb.36': 'ავტომობილის ნომერი',
  'acc.wb.37': 'მძღოლი',
  'acc.wb.38': 'სახელი გვარი',
  'acc.wb.39': 'მძღოლის პირადი ნომერი',
  'acc.wb.40': 'საავტომობილო გადაზიდვისას სავალდებულოა. RS.GE რეესტრში ამოწმებს — შეიყვანე ზუსტად',
  'acc.wb.41': 'ბოლო მძღოლი შევსებულია — თუ სხვაა, შეცვალე.',
  'acc.wb.42': 'საქონელს აბარებს',
  'acc.wb.43': 'შენი მხრიდან — ფორმის 14-ე გრაფა',
  'acc.wb.44': 'საქონელს იბარებს',
  'acc.wb.45': 'მყიდველის მხრიდან — 15-ე გრაფა',
  'acc.wb.46': 'ჩაბარების თარიღი',
  'acc.wb.47': '18-ე გრაფა — თუ არ იცი, დატოვე ცარიელი',
  'acc.wb.48': 'საქონელი — გაყიდვიდან',
  'acc.wb.49': 'გაყიდვის ჯამი ₾',
  'acc.wb.50': ' · ზედნადების ჯამი ₾',
  'acc.wb.51': ' — სხვაობა ბონუსია, რომელიც გადახდაა და არა ფასდაკლება.',
  'acc.wb.52': 'RS.GE-მ ზედნადები არ შეინახა.',
  'acc.wb.53': '(კოდი ',
  'acc.wb.54': 'მოაქვს…',
  'acc.wb.55': 'RS.GE-ს ნიმუშის გამოთხოვა',
  'acc.wb.56': 'RS.GE-ს საკუთარი ზედნადები',
  'acc.wb.57': 'ზედნადები ვერ მოიძებნა',
  'acc.wb.58': 'შაბლონები',
  'acc.wb.59': 'დეტალები',
  'acc.wb.60': 'RS.GE-ს პასუხი',
  'acc.wb.61': 'რა გავაგზავნეთ',
  'acc.wb.62': 'RS.GE-ზე შენახვა (შენახული სტატუსით)',
  'acc.wb.63': 'შენახვის შემდეგ ზედნადები rs.ge-ზე „შენახულებში" გამოჩნდება. იქვე გააქტიურებ ან წაშლი — აქტივაციამდე ის ვერავის დააზარალებს.',
  'acc.fr.1': 'დღის დახურვა (Z-ანგარიში)...',
  'acc.fr.2': 'X-ანგარიში იბეჭდება...',
  'acc.fr.3': 'დღე დაიხურა — Z-ანგარიში ამობეჭდილია',
  'acc.fr.4': 'X-ანგარიში ამობეჭდილია',
  'acc.fr.5': 'ანგარიში ვერ ამოიბეჭდა',
  'acc.fr.6': 'ფისკალური ანგარიშები',
  'acc.fr.7': 'დღის დახურვა (Z) აუცილებელია სამუშაო დღის ბოლოს',
  'acc.fr.8': 'X-ანგარიში',
  'acc.fr.9': 'დღის დახურვა (Z)',
  'acc.fr.10': 'დღის დახურვა — Z-ანგარიში',
  'acc.fr.11': 'ეს დახურავს მიმდინარე ფისკალურ დღეს და განაახლებს დღიურ მთვლელებს აპარატზე. ეს ქმედება შეუქცევადია. გავაგრძელოთ?',
  'acc.fr.12': ' დღის დახურვა',
  'acc.pulse.fiscal': '{n} ფისკალური ჩეკი ვერ გაიცა',
  'acc.pulse.fiscal90': '{n} ფისკალური ჩეკი ვერ გაიცა (ბოლო 90 დღეში)',
  'acc.wd.1': 'ორშ',
  'acc.wd.2': 'სამ',
  'acc.wd.3': 'ოთხ',
  'acc.wd.4': 'ხუთ',
  'acc.wd.5': 'პარ',
  'acc.wd.6': 'შაბ',
  'acc.wd.7': 'კვი',
  'acc.pulse.justNow': 'ახლახან',
  'acc.pulse.minAgo': '{n} წთ წინ',
  'acc.pulse.hAgo': '{n} სთ წინ',
  'acc.evType.sale': 'გაყიდვა',
  'acc.evType.return': 'დაბრუნება',
  'acc.evType.purchase': 'შესყიდვა',
  'acc.evType.expense': 'ხარჯი',
  'acc.evType.shift_open': 'ცვლა გაიხსნა',
  'acc.evType.shift_close': 'ცვლა დაიხურა',
  'acc.evType.cust_pay': 'ნისიის დაფარვა',
  'acc.evType.sup_pay': 'მომწ. გადახდა',
  'acc.evType.drawer_out': 'სალაროდან გატანა',
  'acc.evType.drawer_in': 'სალაროში შეტანა',
  'acc.evType.cart_removed': 'კალათიდან ამოღება',
  'acc.evType.price_change': 'ფასის ცვლილება',
  'acc.ev.gapLess': ' · ნაკლები ₾{amount}, ვიდრე წინა ცვლამ დატოვა',
  'acc.ev.gapMore': ' · მეტი ₾{amount}, ვიდრე წინა ცვლამ დატოვა',
  'acc.ev.counted': ' — დათვლილი ₾{amount}',
  'acc.period.today': 'დღეს',
  'acc.period.week': 'კვირა',
  'acc.period.month': 'თვე',
  'acc.period.all': 'ყველა',
  'acc.tab.overview': 'მიმოხილვა',
  'acc.tab.history': 'გაყიდვების ისტ.',
  'acc.tab.events': 'მოვლენები',
  'acc.tab.inventory': 'პროდუქცია',
  'acc.tab.doctor': 'საწყობის მენეჯერი',
  'acc.tab.purchases': 'შესყიდვები',
  'acc.tab.expenses': 'ხარჯები',
  'acc.tab.reports': 'ანგარიშები',
  'acc.tab.outgoing': 'გამავალი ზედნადები',
  'acc.tab.fiscal': 'RS.GE შედარება',
  'acc.sort.name': 'სახელი',
  'acc.sort.quantity': 'მარაგი',
  'acc.sort.value': 'ღირებულება',
  'acc.sort.potential': 'პოტენციალი',
  'acc.wbStatus.draft': 'შენახული',
  'acc.wbStatus.sent': 'აქტიური',
  'acc.wbStatus.closed': 'დასრულებული',
  'acc.wbStatus.cancelled': 'გაუქმებული',
  'acc.wbStatus.deleted': 'წაშლილი',
  'acc.method.mixed': 'შერეული',
  'acc.method.prepaid': 'წინასწარი თანხით',
  'acc.src.manual': 'ხელით დამატება',
  'acc.src.newModel': 'ახალი მოდელი',
  'acc.src.modelSizes': 'მოდელი — ახალი ზომები',
  'acc.src.rsge': 'RS.GE ზედნადები',
  'acc.src.excel': 'Excel იმპორტი',
  'acc.src.refill': 'ნაშთის შევსება',
  'acc.src.purchase': 'შესყიდვა',
  'acc.recShort.rent': 'ქირა',
  'acc.recShort.salary': 'ხელფასი',
  'acc.recShort.utilities': 'კომუნალური',
  'acc.recShort.transport': 'ტრანსპორტი',
  'acc.recShort.marketing': 'რეკლამა',
  'acc.recShort.bank': 'ბანკი',
  'acc.recShort.taxes': 'გადასახადი',
  'acc.recShort.writeoff': 'ჩამოწერა',
  'acc.recShort.other': 'სხვა',
  'acc.recMode.autoTitle': 'ერთი და იგივეა',
  'acc.recMode.autoSub': 'თავად ჩაიწერება — მაგ. ქირა',
  'acc.recMode.askTitle': 'იცვლება',
  'acc.recMode.askSub': 'იმ დღეს გკითხავს — მაგ. კომუნალური',
  'acc.rec.bookedThis': 'შენახულია — ამ თვის {cat} ხარჯებში ჩაიწერა',
  'acc.rec.bookedN': 'შენახულია — {n} თვის {cat} ხარჯებში ჩაიწერა',
  'acc.tax.status0': 'პროექტი',
  'acc.tax.status1': 'გაგზავნილი',
  'acc.tax.status2': 'დადასტურებული',
  'acc.tax.status3': 'კორექტირებული',
  'acc.tax.status4': 'კორექტირება — ახალი',
  'acc.tax.status5': 'კორექტირება გაგზავნილი',
  'acc.tax.status6': 'გაუქმებული',
  'acc.tax.status7': 'გაუქმება დადასტურებული',
  'acc.tax.status8': 'კორექტირება დადასტურებული',
  'acc.tax.statusN': 'სტატუსი {n}',
  'acc.tax.noNumberYet': 'სერია და ნომერი — გაგზავნისას',
  'acc.ev.removedTimes': 'კალათიდან ამოღება — {n}-ჯერ',
  'acc.ev.afterTimes': 'გადახდის ფანჯრის შემდეგ — {n}-ჯერ · ₾{amount}',
  'acc.ev.priceTimes': '{n}-ჯერ · {products} პროდუქტი',
  'acc.ev.trip': '{name}: ₾{from} → ₾{to} ({down}), უკან {back}-ზე · {who}',
  'acc.ev.count': '{n} მოვლენა',
  'acc.hero.line': ' · გუშინდელი მოგება {profit} · დღეს {n} გაყიდვა · ბრუნვა ₾{revenue}',
  'acc.hero.failed': '{n} ფისკალური ჩეკი ჩავარდა',
  'acc.hero.debtors': '{n} კლიენტი',
  'acc.window.shownFrom': 'გაყიდვები ნაჩვენებია {date}-დან',
  'acc.window.historyFrom': ' · ისტორია {date}-დან',
  'acc.out.toActivate': '{n} ზედნადები გასააქტიურებელია',
  'acc.out.unchecked': '{n} ზედნადების სტატუსი RS.GE-ში ვერ შემოწმდა',
  'acc.rec.bookNow': 'შენახვისას {month} ხარჯი ახლავე ჩაიწერება ({day}), მერე — ყოველ თვე',
  'acc.rec.askNow': 'შენახვისას ახლავე გკითხავს {month} თანხას',
  'acc.rec.firstAuto': 'პირველი ჩაწერა: {day} · მერე — ყოველ თვე',
  'acc.rec.firstAsk': 'პირველი შეხსენება: {day} · მერე — ყოველ თვე',
  'acc.rec.nextAuto': 'შემდეგი ჩაწერა: {day}',
  'acc.rec.nextAsk': 'შემდეგი შეხსენება: {day}',
  'acc.ret.insteadOf': '(₾{amount}-ის ნაცვლად)',
  'acc.doctor.deadLine': '{amount} ({pct}%) დგას {days} დღეზე მეტია გაუყიდავად',
  'acc.doctor.expiring': '{n} პროდუქტს ვადა გასდის — {amount}',
  'acc.lot.expired': '{n} პარტიას ვადა გაუვიდა — {amount}',
  'acc.lot.expiredHint': 'გადაამოწმე თარო: თუ შეფუთვა მართლა ვადაგასულია — ჩამოწერე; თუ თარიღი შეცდომაა — შეასწორე.',
  'acc.lot.soon': '{n} პარტიას {days} დღეში გასდის — {amount}',
  'acc.lot.writeOff': 'პარტიის ჩამოწერა',
  'acc.lot.writeOffShort': 'ჩამოწერა',
  'acc.lot.writeOffGo': 'ჩამოწერე {qty}',
  'acc.lot.edit': 'პარტიის შესწორება',
  'acc.lot.editShort': 'შესწორება',
  'acc.lot.dateIt': 'ვადის მიწერა',
  'acc.lot.qtyOut': 'რამდენი ჩამოიწეროს',
  'acc.lot.qtyKeep': 'რამდენს აქვს ეს ვადა',
  'acc.lot.qtyKeepHint': 'დანარჩენი „ვადა არ მითითებულა“-ში გადავა; მარაგი არ იცვლება.',
  'acc.lot.window': 'ვადა',
  'acc.lot.windowSee': 'ნახვა',
  'acc.lot.wExpired': '{n} პარტიას ვადა გაუვიდა',
  'acc.lot.wSoon': '{n} პარტიას 7 დღეში გასდის',
  'acc.lot.windowLater': 'მოგვიანებით',
  'acc.lot.bell': 'ვადა: {n} პარტია',
  'acc.ai.title': 'AI მენეჯერი',
  'acc.ai.ask': 'ჰკითხე AI მენეჯერს',
  'acc.ai.askBtn': 'ჰკითხე',
  'acc.ai.close': 'დახურვა',
  'acc.ai.sub': 'შენი მაღაზიის ციფრებით',
  'acc.ai.hello': 'ჰკითხე გაყიდვაზე, მოგებაზე, მარაგზე, ვალებზე, ხარჯებზე ან ცვლებზე — გიპასუხებ შენი მაღაზიის ციფრებით.',
  'acc.ai.noteOf': 'დილის შენიშვნა · {day}',
  'acc.ai.placeholder': 'ჰკითხე: რა გავყიდე ამ კვირაში?',
  'acc.ai.thinking': 'ვითვლი…',
  'acc.ai.failed': 'ახლა ვერ ვუპასუხე — შეამოწმე ინტერნეტი და სცადე თავიდან.',
  'acc.ai.s1': 'რა გავყიდე ამ კვირაში?',
  'acc.ai.s2': 'რა არ გაყიდულა 30 დღეში?',
  'acc.ai.s3': 'ვის რამდენი მართებს?',
  'acc.ai.how': 'ციფრები გუშინდელი ანგარიშიდანაა და შემოწმებულია; ტექსტი Gemini-მ დაწერა. იგივე შენიშვნა Telegram-ის დილის ანგარიშშიცაა.',

  // 128 — units by IMEI / serial on a sale and its return
  'acc.ret.pickUnits': 'მონიშნე, რომელი ერთეული ბრუნდება:',
  'acc.ret.unitBack': 'უკვე დაბრუნდა',
  'acc.ret.err.serialNotInSale': 'ეს ნომერი ამ გაყიდვაში არ ყოფილა.',
  'acc.ret.err.serialReturned': 'ეს ერთეული უკვე დაბრუნებულია.',
  'acc.hist.until': 'გარანტია {date}-მდე',
  'hist.ingr.tag': 'ფასში',
  'ret.ingr.note': '{list} მარაგს თავისით დაუბრუნდება.',

  // 129 — a branch transfer's internal-transport waybill
  'acc.wb.transferTitle': 'შიდა გადაზიდვის ზედნადები',
  'acc.wb.transferDesc': '{from} → {to}. RS.GE-ზე შეინახება პროექტად — გააქტიურება შენი გადაწყვეტილებაა, გამავალი ზედნადებების სიიდან.',
  'acc.wb.transferNote': 'შიდა გადაზიდვისას საქონელი ისევ შენია: მიმღებად შენი კომპანიაა ჩაწერილი (კოდი და დასახელება — პარამეტრებიდან), მისამართები — ფილიალებისაა, ფასი — თვითღირებულება.',
  'acc.wb.list.transfer': 'შიდა გადაზიდვა: {from} → {to}',
  'acc.wb.noCredsTitle': 'RS.GE ჯერ არ არის დაკავშირებული',
  'acc.wb.noCredsBody': 'პარამეტრები → RS.GE: ჩაწერე სერვის მომხმარებელი და პაროლი. ამის მერე ზედნადები აქედანვე შეინახება RS.GE-ზე.',
  // 131 — the reports tab's „what moved between branches" card (components/accounting/transfer-flows-card.tsx)
  'acc.tr.title': 'ფილიალებს შორის გადატანა',
  'acc.tr.sub': 'თვითღირებულებით, გადატანის დღის ფასით. გადადის საქონელი და არა ფული: შესყიდვა იმ ფილიალს რჩება, ვინც გადაიხადა, მოგება კი იმას ეწერება, ვინც გაყიდა.',
  'acc.tr.total': '{n} გადატანა · {qty} ც. · ₾{value}',
  'acc.tr.branches': 'ფილიალების მიხედვით',
  'acc.tr.in': 'მიიღო',
  'acc.tr.out': 'გასცა',
  'acc.tr.net': 'სხვაობა',
  'acc.tr.qty': '{qty} ც.',
  'acc.tr.routes': 'მიმართულებები',
  'acc.tr.routeLine': '{n} გადატანა · {qty} ც.',
  'acc.tr.empty': 'ამ პერიოდში ფილიალებს შორის გადატანა არ ყოფილა.',
  'acc.tr.estimated': '{n} ხაზს გადატანის დღის ღირებულება არ ჰქონდა და დღევანდელით დაითვალა.',
  'acc.tr.unpriced': '{n} ხაზის პროდუქტი წაშლილია, ამიტომ ₾0-ით ითვლება.',
  // 1.36
  'acc.hist.exchange': 'გაცვლა',
  'acc.purch.returned': 'დაბრუნებული მომწოდებლებთან',
  'acc.evType.sup_return': 'მომწოდებელთან დაბრუნება',
  'acc.ev.supReturn': 'დაბრუნება მომწოდებელთან — ₾{amount} ({way})',
} as const
